var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "title": _vm.notification.title,
      "ok-only": "",
      "centered": ""
    },
    model: {
      value: _vm.isShow,
      callback: function callback($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('div', [_vm.notification.related_url ? _c('a', {
    attrs: {
      "href": _vm.notification.related_url,
      "target": "_blank"
    }
  }, [_vm._v("參考網址：" + _vm._s(_vm.notification.related_url))]) : _vm._e()]), _c('div', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v(_vm._s(_vm.notification.content))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }